import type React from "react";
import { Button, Dropdown } from "react-bootstrap";
import { type Case, ExternalPartners } from "@/briefpoint-client";
import ClioLogo from "@/images/Glyph_Clio Glyph Blue.svg?react";
import BriefpointLogo from "@/images/logo.svg?react";
import MyCaseLogo from "@/images/MyCase.svg?react";
import SmokeballLogo from "@/images/Smokeball_logo_mark.svg?react";
import type { UserResponse } from "@/lib/types";

export function getPartnerLogo(partner?: ExternalPartners) {
  if (!partner) {
    return null;
  }

  switch (partner) {
    case ExternalPartners.Clio:
      return (
        <ClioLogo
          title="Clio"
          style={{ width: "16px", marginRight: "0.25em" }}
        />
      );
    case ExternalPartners.Smokeball:
      return (
        <SmokeballLogo
          title="Smokeball"
          style={{ width: "16px", marginRight: "0.25em" }}
        />
      );
    case ExternalPartners.MyCase:
      return (
        <MyCaseLogo
          title="MyCase"
          style={{ width: "16px", marginRight: "0.25em" }}
        />
      );
    default:
      return null;
  }
}

function ExternalPartnerMenu({
  _case,
  user,
  externalAction,
  bpDefault,
  isUploading,
}: {
  _case?: Case;
  user?: UserResponse;
  externalAction: React.Dispatch<React.SetStateAction<boolean>>;
  bpDefault: (e: React.MouseEvent) => void;
  isUploading?: boolean;
}) {
  return (
    <>
      {_case?.integration?.identifier || user?.externalConnection?.isActive ? (
        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic" size="sm">
            Respond
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={() => externalAction(true)}>
              {getPartnerLogo(
                _case?.integration?.partner ||
                  user?.externalConnection?.partner,
              )}{" "}
              From{" "}
              {_case?.integration?.partner || user?.externalConnection?.partner}
            </Dropdown.Item>
            <Dropdown.Item onClick={bpDefault}>
              <BriefpointLogo
                style={{
                  width: "16px",
                  marginRight: "0.25em",
                  // height: "16px",
                  // objectFit: "contain",
                }}
              />{" "}
              From your computer
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <Button
          variant="primary"
          size="sm"
          onClick={bpDefault}
          disabled={isUploading}
        >
          {isUploading ? "Uploading..." : "Respond"}
        </Button>
      )}
    </>
  );
}

export default ExternalPartnerMenu;
